const PLACEHOLDER = 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=900&q=60';

export const getPrimaryImageUrl = (product) => {
  if (!product) return PLACEHOLDER;
  const images = product.images || [];
  const featured = images.find(img => img.featured && img.url);
  const firstImage = images.find(img => img.url);

  if (product.featured_image_url) return product.featured_image_url;
  if (featured && featured.url) return featured.url;
  if (firstImage && firstImage.url) return firstImage.url;
  if (product.hero_image_url) return product.hero_image_url;
  return PLACEHOLDER;
};

export default getPrimaryImageUrl;
